module.exports = __webpack_public_path__ + "img/favorite.4619c446.svg";